export interface Option {
    id: string
    namespace: OptionNamespace
    label: string
    name?: string
    description?: string
    metadata?: {
        priority?: string
        send_admission_message?: boolean
        [key: string]: any
    }
}

export enum OptionNamespace {
    callDecision = 'call_decision',
    callReason = 'call_reason',
    diagnosis = 'diagnosis',
}
